module.exports = __webpack_public_path__ + "static/pa_2-293acd57cca0764be349afc041f220b7.jpg";